var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { autoinject } from "aurelia-framework";
import { TokenClient } from "../../../services/authentication/token-client.service";
import { transient } from "aurelia-dependency-injection";
import { Router } from "aurelia-router";
import { NotificationClientService, NotificationType } from "../../../services/basics/notification-client.service";
import { GenesisRouterConstants } from "../../../configuration/router.constants";
import { I18N } from 'aurelia-i18n';
import { EntityValidationsService } from "../../../client-validation-system/validations-service";
import { ValidationTypeEnum, ValidationActivation } from "../../../client-validation-system/validations.models";
var Login = /** @class */ (function () {
    function Login(tokenClient, notificationClientService, entityValidationsService, router, i18N) {
        this.tokenClient = tokenClient;
        this.notificationClientService = notificationClientService;
        this.entityValidationsService = entityValidationsService;
        this.router = router;
        this.i18N = i18N;
        this.messageNotificationString = null;
        this.providerHandlers = [];
    }
    Login.prototype.activate = function (params, navigationInstruction) {
        this.canSignup = navigationInstruction.canSignup;
        this.returnUrl = params.returnUrl ? params.returnUrl : null;
        this.canLoginWithProviders = navigationInstruction.canLoginWithProviders;
        this.providerHandlers = navigationInstruction.providerHandlers;
    };
    Login.prototype.attached = function () {
        var rulesHolder = {
            activation: ValidationActivation.Always,
            entityName: "Login",
            isCollection: false,
            nestedRulesHolder: [],
            rules: [{
                    errorMessage: this.i18N.tr('email-required-text'),
                    parameters: null, property: "email",
                    validationType: ValidationTypeEnum.Required
                }, {
                    errorMessage: this.i18N.tr('email-invalid-text'),
                    parameters: null, property: "email",
                    validationType: ValidationTypeEnum.Email
                }, {
                    errorMessage: this.i18N.tr('password-required-text'),
                    parameters: null, property: "password",
                    validationType: ValidationTypeEnum.Required
                }]
        };
        this.validator = this.entityValidationsService.getValidator(this, rulesHolder);
    };
    Login.prototype.forgotPassword = function () {
        this.router.navigateToRoute(GenesisRouterConstants.RouteNames.ForgotPassword);
    };
    Login.prototype.register = function () {
        var queryString = location.href.split('?');
        if (queryString.length > 1) {
            var queryStringObj_1 = {};
            queryString[1].split('&').forEach(function (z) {
                var key = z.split('=')[0];
                var value = z.split('=')[1];
                queryStringObj_1[key] = value;
            });
            this.router.navigateToRoute(GenesisRouterConstants.RouteNames.Register, queryStringObj_1);
        }
        else {
            this.router.navigateToRoute(GenesisRouterConstants.RouteNames.Register);
        }
    };
    Login.prototype.submit = function () {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var validationResponse, response, error_1, reasonPhrase, token, message, genericMessage;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.messageNotificationString = null;
                        this.submitting = true;
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 4, 5, 6]);
                        return [4 /*yield*/, this.validator.validate()];
                    case 2:
                        validationResponse = _b.sent();
                        if (!validationResponse.valid) {
                            throw "Please enter a valid email and password.";
                        }
                        return [4 /*yield*/, this.tokenClient.login({
                                email: this.email,
                                password: this.password
                            })];
                    case 3:
                        response = _b.sent();
                        // no auth cookie is issued until the second factor passes
                        if (response && response.requiresTwoFactorSetup) {
                            this.router.navigateToRoute(GenesisRouterConstants.RouteNames.TwoFactorSetup);
                            return [2 /*return*/];
                        }
                        if (response && response.requiresTwoFactor) {
                            this.router.navigateToRoute(GenesisRouterConstants.RouteNames.TwoFactor);
                            return [2 /*return*/];
                        }
                        location.reload();
                        return [3 /*break*/, 6];
                    case 4:
                        error_1 = _b.sent();
                        reasonPhrase = ((_a = error_1 === null || error_1 === void 0 ? void 0 : error_1.content) === null || _a === void 0 ? void 0 : _a.reasonPhrase) || (error_1 === null || error_1 === void 0 ? void 0 : error_1.reasonPhrase);
                        token = (error_1 === null || error_1 === void 0 ? void 0 : error_1.headers) ? error_1.headers.get("token") : null;
                        message = void 0;
                        genericMessage = this.i18N.tr('login-wrong-credentials-text');
                        message = genericMessage;
                        // Show both a notification and inline message
                        this.messageNotificationString = message;
                        this.notificationClientService.show(this.i18N.tr('login-failed-text'), message, NotificationType.Error);
                        if (reasonPhrase === "password-expired" && token) {
                            this.router.addRoute({
                                moduleId: "./views/pages/authentication/change-password",
                                name: "change-password",
                                route: "change-password/:token?",
                                title: this.i18N.tr("change-password-text"),
                                auth: false
                            });
                            this.router.navigateToRoute("change-password", { token: token });
                        }
                        return [3 /*break*/, 6];
                    case 5:
                        this.submitting = false;
                        return [7 /*endfinally*/];
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    Login = __decorate([
        autoinject,
        transient(),
        __metadata("design:paramtypes", [TokenClient,
            NotificationClientService,
            EntityValidationsService,
            Router,
            I18N])
    ], Login);
    return Login;
}());
export { Login };
